<template>
  <div>
    <swiper :options="swiperOption">
      <swiper-slide><a target="_blank" href="https://help.meiwulist.com/help/msq/pages/2025/announcement.html"><img style="width:100%; height: 230px;" src="https://shouqu.oss-cn-shanghai.aliyuncs.com/cms/160/images/1744364340332213515.png"/></a> </swiper-slide>
      <swiper-slide><a target="_blank" href="https://help.meiwulist.com/push/2018/0930website.html"><img style="width:100%" src="https://shouqu.oss-cn-shanghai.aliyuncs.com/cms/162/images/1665214494028986505.png"/></a> </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/dist/swiper.css'

export default {
  name: "UserRead",
  components: { swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  }

}
</script>

<style>
.swiper-pagination-bullet-active {
  background: #ffffff;
}
</style>